<template>

	<page>
		<title-view>הגרלות
			<v-btn slot="actions" v-if="isAdmin" color="primary" btn @click="onEdit({})">הוספת הגרלה</v-btn>
		</title-view>
		<row>
			<c-col>
				<lotteries-table @edit="onEdit" @package="openPackageModal"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת הגרלות</span>
			<form-builder modelName="lottery" @save="openModal=false" module="LotteryModule" :inputs="inputs"/>
		</popup-dialog>
		<popup-dialog v-model="lotteryModal">
			<span slot="header">יצירת/עריכת הגרלות</span>
			<packages-view/>
		</popup-dialog>

	</page>


</template>

<script>

	import LotteriesTable from "src/views/lotteries/LotteriesTable";
	import LotteryModule from "src/store/modules/Lottery.module";
	import FormBuilder from "../../components/form/FormBuilder";
	import PackagesView from "../packages/PackagesView";
	import {mapGetters} from "vuex";
	import MediaGalleryPreview from "../../components/gallery/MediaGalleryPreview";

	export default {
		name: "lotteries-view",
		components: {PackagesView, FormBuilder, LotteriesTable},
		data() {
			return {
				openModal: false,
				lotteryModal: false
			};
		},
		computed: {
			...mapGetters([
				"isAdmin",
			]),
			module() {
				return LotteryModule;
			},
			inputs() {
				return [
					{label: "כותרת", name: "title"},
					{label: "כותרת משנה", name: "subtitle"},
					{label: "תיאור", name: "description", textarea: true},
					{label: "תאריך התחלה", name: "start_at", type: "datetime-local"},
					{label: "תאריך סיום", name: "end_at", type: "datetime-local"},
					{label: "logo", name: "logo", component: MediaGalleryPreview},
					{label: "לקוח מקבל כרטיס פר מספר כרטיסים", name: "win_card_per", type: "number"},
					{label: "גוגל תג", name: "google_tag"},
					{label: "פייסבוק פיקסל", name: "fbq"},
				];
			}
		},
		methods: {
			onEdit(lottery) {
				this.$store.commit(LotteryModule.types.GET, lottery);
				this.openModal = true;
			},
			openPackageModal(lottery) {
				this.$store.commit(LotteryModule.types.GET, lottery);
				this.lotteryModal = true;

			}
		}

	};
</script>

<style scoped>

</style>
